import { UserSliceDTO } from 'features/user/forms/UserEmployeeForm/types'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const EMPLOYEE_FRAGMENT: TypedDocumentNode<UserSliceDTO> = gql`
  fragment EmployeeFragment on User {
    id
    email
    role
  }
`
